import React, { useEffect, useState } from 'react';
import {
	Case,
	useMonitoringCentreCasesQuery,
} from '../../../../graphql/graphql';
import MonitoringCenterSolvedRequestsFilter from './MonitoringCenterSolvedRequestsFilter';
import MonitoringCenterList from '../MonitoringCenterList/MonitoringCenterList';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';
import { CustomSettingKey } from '../../../Base/Enums/CustomSettingKey.enum';
import MonitoringCenterSettingsPanel from '../MonitoringCenterSettings/MonitoringCenterSettingsPanel';
import styles from './MonitoringCenterSolvedRequests.module.scss';
import { CustomSettingsContextProvider } from '../../../CustomSettings/Services/CustomSettingsContext';
import { MonitoringCenterSolvedCasesColumns } from '../../Consts/MonitoringCenterSolvedCasesColumns.const';
import { useFlatDataList } from '../../../Base/Hooks/useFlatDataList';

const MonitoringCenterSolvedRequests: React.FC = () => {
	const [filter, setFilter] = useState<object>({ solved: true });
	const { flatData, pagination, getNextPage, appendData } =
		useFlatDataList<Case>(filter);
	const { data, isLoading, refetch } = useMonitoringCentreCasesQuery({
		...filter,
		pagination,
	});

	useEffect(() => {
		appendData((data?.monitoringCentreCases?.data as Case[]) ?? []);
	}, [data]);

	useEffect(() => {
		refetch();
	}, [filter]);

	useSocket(Socket.CASE_TAKEN, refetch);

	return (
		<CustomSettingsContextProvider
			customSettingsKey={CustomSettingKey.MONITORING_CENTER_SOLVED_REQUESTS}>
			<div className={styles.wrapper}>
				<MonitoringCenterSettingsPanel
					customSettingKey={CustomSettingKey.MONITORING_CENTER_SOLVED_REQUESTS}
				/>
				<MonitoringCenterSolvedRequestsFilter onFilter={setFilter} />
				<MonitoringCenterList
					data={flatData}
					onLoadMore={getNextPage}
					onRefresh={refetch}
					isLoading={isLoading}
					hasMoreData={data?.monitoringCentreCases?.meta?.hasNextPage || false}
					columns={MonitoringCenterSolvedCasesColumns}
				/>
			</div>
		</CustomSettingsContextProvider>
	);
};

export default MonitoringCenterSolvedRequests;
